import Http from "./http";

// Fetch AI campaign list (paginated) for the current brand.
export const getAllAiCampaignsAPI = (payload) => {
  return Http.post("admin/campaign/list", payload);
};

